import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=5cd4b7ec&scoped=true"
import script from "./ExamHistory.vue?vue&type=script&lang=js"
export * from "./ExamHistory.vue?vue&type=script&lang=js"
import style0 from "./ExamHistory.vue?vue&type=style&index=0&id=5cd4b7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4b7ec",
  null
  
)

export default component.exports